/* RIORA Day Support PDP — gallery + plan selector behaviour (Dawn theme) */
(function () {
  'use strict';

  /* The homepage Product Embed swaps the PDP buy box in after page load. It sets __rioraPdpWait so this
     file does nothing until the swap is done, then runs it again with __rioraPdpGo set. Otherwise another
     section's copy of this file runs first and the swapped-in gallery and buy box never get their clicks. */
  if (window.__rioraPdpWait && !window.__rioraPdpGo) return;
  if (window.__rioraPdpInit) return;
  window.__rioraPdpInit = true;

  /* ---------- Gallery: slide-based viewport + scrollable thumbnail slider ---------- */
  document.querySelectorAll('[data-riora-gallery]').forEach(function (gallery) {
    var viewport = gallery.querySelector('[data-riora-viewport]');
    var slides = Array.from(gallery.querySelectorAll('[data-riora-slide]'));
    var thumbs = Array.from(gallery.querySelectorAll('[data-riora-thumb]'));
    var thumbGrid = gallery.querySelector('[data-riora-thumb-grid]');
    var prevBtn = gallery.querySelector('[data-riora-thumb-prev]');
    var nextBtn = gallery.querySelector('[data-riora-thumb-next]');
    if (!slides.length) return;
    var curIndex = 0;

    function updateThumbArrows() {
      if (!prevBtn || !nextBtn) return;
      prevBtn.disabled = curIndex <= 0;
      nextBtn.disabled = curIndex >= slides.length - 1;
    }

    function scrollActiveThumbIntoView() {
      var activeThumb = thumbs[curIndex];
      if (!thumbGrid || !activeThumb) return;
      var gridRect = thumbGrid.getBoundingClientRect();
      var thumbRect = activeThumb.getBoundingClientRect();
      var left = thumbGrid.scrollLeft + (thumbRect.left - gridRect.left) - (gridRect.width - thumbRect.width) / 2;
      thumbGrid.scrollTo({ left: Math.max(0, left), behavior: 'smooth' });
    }

    function showSlide(i) {
      if (i < 0) i = slides.length - 1;
      if (i >= slides.length) i = 0;
      curIndex = i;
      slides.forEach(function (s, idx) { s.classList.toggle('is-active', idx === i); });
      thumbs.forEach(function (t, idx) {
        t.classList.toggle('is-active', idx === i);
        t.setAttribute('aria-pressed', idx === i ? 'true' : 'false');
      });
      updateThumbArrows();
      scrollActiveThumbIntoView();
    }

    thumbs.forEach(function (thumb, i) {
      thumb.addEventListener('click', function () { showSlide(i); });
    });

    if (thumbGrid && prevBtn && nextBtn) {
      prevBtn.addEventListener('click', function () { showSlide(curIndex - 1); });
      nextBtn.addEventListener('click', function () { showSlide(curIndex + 1); });
      updateThumbArrows();
    }

    if (viewport && slides.length > 1) {
      var touchStartX = 0;
      viewport.addEventListener('touchstart', function (e) {
        touchStartX = e.changedTouches[0].screenX;
      }, { passive: true });
      viewport.addEventListener('touchend', function (e) {
        var diff = touchStartX - e.changedTouches[0].screenX;
        if (Math.abs(diff) > 50) showSlide(curIndex + (diff > 0 ? 1 : -1));
      }, { passive: true });
    }
  });

  /* ---------- Sticky add-to-cart: show once the primary Add to Cart button scrolls above the viewport ---------- */
  (function () {
    var primaryAtc = document.querySelector('[data-riora-primary-atc]');
    var stickyCta = document.querySelector('.riora-sticky-cta');
    if (!primaryAtc || !stickyCta || typeof IntersectionObserver === 'undefined') return;
    var observer = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        var scrolledPast = !entry.isIntersecting && entry.boundingClientRect.top < 0;
        stickyCta.classList.toggle('is-visible', scrolledPast);
        stickyCta.setAttribute('aria-hidden', scrolledPast ? 'false' : 'true');
        stickyCta.inert = !scrolledPast;
      });
    }, { threshold: 0 });
    observer.observe(primaryAtc);
  })();

  /* ---------- Sticky add-to-cart: click delegates to whatever the real, currently
     visible add-to-cart control is (our own buybox, or a subscription app's widget
     like Loop) so Subscribe & Save selections are respected instead of always
     submitting a fixed one-time form. ---------- */
  document.querySelectorAll('[data-riora-sticky-cta]').forEach(function (stickyCta) {
    var sectionId = stickyCta.getAttribute('data-riora-sticky-cta');
    var scope = document.getElementById('shopify-section-' + sectionId) || document;
    var stickyBtn = stickyCta.querySelector('[data-riora-sticky-atc]');
    if (!stickyBtn) return;

    function findRealAtc() {
      var primary = scope.querySelector('[data-riora-primary-atc]:not([disabled])');
      if (primary) return primary;
      var candidates = Array.prototype.slice.call(scope.querySelectorAll('button, input[type="submit"]')).filter(function (el) {
        return el !== stickyBtn && !el.closest('.riora-sticky-cta') && el.offsetParent !== null && !el.disabled;
      });
      var byLabel = candidates.filter(function (el) {
        var label = (el.textContent || el.value || '').toLowerCase();
        return label.indexOf('cart') !== -1 || label.indexOf('subscri') !== -1;
      });
      return byLabel[byLabel.length - 1] || candidates[candidates.length - 1] || null;
    }

    // The whole sticky bar is clickable, not just its button.
    stickyCta.addEventListener('click', function (e) { if (!e.target.closest('a, button')) stickyBtn.click(); });

    stickyBtn.addEventListener('click', function () {
      var box = scope.querySelector('[data-riora-buybox]') || scope.querySelector('.riora-buybox') || document.getElementById('riora-buy');
      if (!box) {
        var target = findRealAtc();
        if (target) target.scrollIntoView({ behavior: 'smooth', block: 'center' });
        return;
      }
      var offset = 16;
      var header = document.querySelector('.shopify-section-header-sticky');
      if (header) offset += header.offsetHeight;
      var bar = document.getElementById('riora-announcement-bar');
      if (bar && bar.getAttribute('data-sticky') === 'true') offset += bar.offsetHeight;
      var top = box.getBoundingClientRect().top + window.pageYOffset - offset;
      window.scrollTo({ top: Math.max(0, top), behavior: 'smooth' });
    });
  });

  /* ---------- Sticky add-to-cart: mirror Loop's live subscription price ----------
     Loop renders the selected frequency's price into a div whose id starts with
     "loop-widget-purchase-option-price-id-" and only its text changes as the
     shopper clicks a different "Deliver every N days" option. Watch that text
     and copy it into the sticky bar so the two never fall out of sync. ---------- */
  (function () {
    var stickyPriceEls = document.querySelectorAll('[data-riora-sticky-price]');
    if (!stickyPriceEls.length) return;

    var attached = false;
    function attach(priceEl) {
      if (attached) return;
      attached = true;
      function sync() {
        var text = priceEl.textContent.trim();
        if (text) stickyPriceEls.forEach(function (el) { el.textContent = text; });
      }
      sync();
      new MutationObserver(sync).observe(priceEl, { childList: true, characterData: true, subtree: true });
    }

    var existing = document.querySelector('[id^="loop-widget-purchase-option-price-id-"]');
    if (existing) {
      attach(existing);
    } else if (typeof MutationObserver !== 'undefined') {
      var bodyObserver = new MutationObserver(function () {
        var el = document.querySelector('[id^="loop-widget-purchase-option-price-id-"]');
        if (el) {
          attach(el);
          bodyObserver.disconnect();
        }
      });
      bodyObserver.observe(document.body, { childList: true, subtree: true });
    }
  })();

  /* ---------- Buy box: keep hidden inputs in sync with chosen plan ----------
     Each radio carries data-variant-id and (optionally) data-selling-plan-id.
     The form posts /cart/add with id (+ selling_plan when subscribing).     */
  document.querySelectorAll('[data-riora-buybox]').forEach(function (box) {
    var form = box.querySelector('form[data-type="add-to-cart-form"], form[action*="/cart/add"]');
    if (!form) return;
    var idInput = form.querySelector('input[name="id"]');
    var planInput = form.querySelector('input[name="selling_plan"]');
    var qtyInput = form.querySelector('input[name="quantity"]');
    var scope = box.closest('[id^="shopify-section-"]') || document;
    var stickyPriceEls = scope.querySelectorAll('[data-riora-sticky-price]');
    var stickyPlanLabelEls = scope.querySelectorAll('[data-riora-sticky-plan-label]');
    var stickyCompareEls = scope.querySelectorAll('[data-riora-sticky-compare]');
    var stickySaveEls = scope.querySelectorAll('[data-riora-sticky-save]');
    var stickyDefaultEls = scope.querySelectorAll('[data-riora-sticky-default]');
    var giftRows = scope.querySelectorAll('[data-riora-gift-plans]');
    var giftsBox = scope.querySelector('[data-riora-gifts]');
    var planNoteEls = scope.querySelectorAll('[data-riora-plan-note]');

    function sync(radio) {
      if (!radio) return;
      if (idInput) idInput.value = radio.getAttribute('data-variant-id') || idInput.value;
      if (qtyInput) qtyInput.value = radio.getAttribute('data-quantity') || '1';
      var sp = radio.getAttribute('data-selling-plan-id');
      if (planInput) {
        if (sp) {
          planInput.value = sp;
          planInput.disabled = false;
        } else {
          planInput.value = '';
          planInput.disabled = true;
        }
      }
      if (giftsBox) giftsBox.style.opacity = sp ? '' : '0.3';
      var priceFormatted = radio.getAttribute('data-price-formatted');
      if (priceFormatted) stickyPriceEls.forEach(function (el) { el.textContent = priceFormatted; });

      var cmpText = radio.getAttribute('data-compare-formatted') || '';
      var savePct = radio.getAttribute('data-save-pct') || '';
      stickyCompareEls.forEach(function (el) { el.textContent = cmpText; el.hidden = !cmpText; });
      stickySaveEls.forEach(function (el) { el.textContent = savePct ? 'GET ' + savePct + '% OFF + Free Gifts' : ''; el.hidden = !savePct; });
      stickyDefaultEls.forEach(function (el) { el.hidden = !!savePct; });

      var planLabel = radio.getAttribute('data-plan-label');
      if (planLabel) stickyPlanLabelEls.forEach(function (el) { el.textContent = planLabel; });

      var tier = parseInt(radio.getAttribute('data-riora-plan-tier'), 10) || 1;
      planNoteEls.forEach(function (el) {
        var note = el.getAttribute('data-note-' + tier) || '';
        el.textContent = note;
        el.hidden = !note;
      });
      giftRows.forEach(function (row) {
        var giftPlans = (row.getAttribute('data-riora-gift-plans') || '').split(',').filter(Boolean);
        row.classList.toggle('riora-buybox__gift-row--locked', giftPlans.indexOf(String(tier)) === -1);
      });
    }

    var radios = box.querySelectorAll('input[type="radio"][name^="riora-plan"]');
    radios.forEach(function (radio) {
      radio.addEventListener('change', function () { sync(radio); });
    });
    sync(box.querySelector('input[type="radio"][name^="riora-plan"]:checked'));

    /* Add to cart (+ any unlocked gift-with-purchase items) via fetch, then open the
       cart drawer instead of jumping straight to checkout. */
    form.addEventListener('submit', function (e) {
      e.preventDefault();

      var isSubscription = !!(planInput && !planInput.disabled && planInput.value);

      var giftVariantIds = [];
      if (isSubscription) {
        giftRows.forEach(function (row) {
          if (row.classList.contains('riora-buybox__gift-row--locked')) return;
          var vid = row.getAttribute('data-riora-gift-variant-id');
          if (vid) giftVariantIds.push(vid);
        });
      }

      var mainItem = { id: idInput.value, quantity: qtyInput ? qtyInput.value : 1 };
      if (planInput && !planInput.disabled && planInput.value) mainItem.selling_plan = planInput.value;
      if (!window.rioraAddWithGifts) { form.submit(); return; }
      window.rioraAddWithGifts(mainItem, giftVariantIds).catch(function () { form.submit(); });
    });
  });

  /* ---------- Buy box: "one-time purchase" note link adds to cart + opens the
     drawer, instead of jumping straight to checkout via the /cart/<id>:1?checkout
     permalink. ---------- */
  document.addEventListener('click', function (e) {
    var trigger = e.target.closest('[data-riora-otp-add]');
    if (!trigger) return;
    var variantId = trigger.getAttribute('data-riora-otp-variant-id');
    if (!variantId) return;

    e.preventDefault();
    trigger.classList.add('is-loading');

    var cartDrawer = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
    var body = { items: [{ id: variantId, quantity: 1 }] };
    if (cartDrawer && cartDrawer.getSectionsToRender) {
      body.sections = cartDrawer.getSectionsToRender().map(function (s) { return s.id; });
      body.sections_url = window.location.pathname;
    }

    fetch(window.Shopify && window.Shopify.routes && window.Shopify.routes.cart_add_url ? window.Shopify.routes.cart_add_url : '/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify(body)
    })
      .then(function (res) { if (!res.ok) throw new Error('cart add failed'); return res.json(); })
      .then(function (res) {
        if (cartDrawer && cartDrawer.renderContents) { cartDrawer.renderContents(res); }
        else { window.location.href = (window.Shopify && window.Shopify.routes && window.Shopify.routes.cart_url) || '/cart'; }
      })
      .catch(function () { window.location.href = trigger.href; })
      .finally(function () { trigger.classList.remove('is-loading'); });
  });

  /* ---------- Review showcase video cards: click poster to play the real video inline ----------
     Only one card should ever be playing at once — pause and re-hide every other player
     first, so starting a second video doesn't leave the first one running behind it. */
  document.querySelectorAll('[data-riora-video-trigger]').forEach(function (media) {
    media.addEventListener('click', function () {
      var player = media.querySelector('.riora-rvsc__video-player');
      if (!player) return;
      document.querySelectorAll('.riora-rvsc__video-player video').forEach(function (v) {
        if (v === player.querySelector('video')) return;
        v.pause();
        var otherPlayer = v.closest('.riora-rvsc__video-player');
        if (otherPlayer) otherPlayer.hidden = true;
        var otherMedia = v.closest('[data-riora-video-trigger]');
        if (otherMedia) otherMedia.classList.remove('riora-rvsc__video-media--playing');
      });
      player.hidden = false;
      media.classList.add('riora-rvsc__video-media--playing');
      var video = player.querySelector('video');
      if (video) video.play();
    });
  });

  /* ---------- Real impact video cards: click poster to play the real video inline ----------
     Same single-active-video rule as the review showcase above. */
  document.querySelectorAll('.riora-rimp__media[data-riora-video-trigger]').forEach(function (media) {
    media.addEventListener('click', function () {
      var player = media.querySelector('.riora-rimp__video-player');
      if (!player) return;
      var tpl = player.querySelector('template[data-riora-video-template]');
      if (tpl && !player.querySelector('video')) { player.appendChild(tpl.content.cloneNode(true)); }
      document.querySelectorAll('.riora-rimp__video-player video').forEach(function (v) {
        if (v === player.querySelector('video')) return;
        v.pause();
        var otherPlayer = v.closest('.riora-rimp__video-player');
        if (otherPlayer) otherPlayer.hidden = true;
        var otherMedia = v.closest('.riora-rimp__media');
        if (otherMedia) otherMedia.classList.remove('riora-rimp__media--playing');
      });
      player.hidden = false;
      media.classList.add('riora-rimp__media--playing');
      var video = player.querySelector('video');
      if (video) video.play();
    });
  });

  /* ---------- Image popup dialogs: "View the full label" / "View test report" ----------
     showModal() alone doesn't reliably stop the page behind it from touch-scrolling on
     iOS/some Android browsers, so lock body scroll manually while any of these are open. */
  var rioraOpenModalCount = 0;
  var rioraLockedScrollY = 0;
  function rioraLockBodyScroll() {
    if (rioraOpenModalCount === 0) {
      rioraLockedScrollY = window.scrollY;
      document.body.style.position = 'fixed';
      document.body.style.top = '-' + rioraLockedScrollY + 'px';
      document.body.style.width = '100%';
    }
    rioraOpenModalCount++;
  }
  function rioraUnlockBodyScroll() {
    rioraOpenModalCount = Math.max(0, rioraOpenModalCount - 1);
    if (rioraOpenModalCount === 0) {
      document.body.style.position = '';
      document.body.style.top = '';
      document.body.style.width = '';
      window.scrollTo(0, rioraLockedScrollY);
    }
  }

  function setupImagePopupModal(modalId, triggerAttr, closeAttr) {
    var modal = document.getElementById(modalId);
    if (!modal) return;
    var modalClose = modal.querySelector('[' + closeAttr + ']');
    var lastTrigger = null;

    function openModal(trigger) {
      lastTrigger = trigger || null;
      if (typeof modal.showModal === 'function') {
        modal.showModal();
      } else {
        modal.setAttribute('open', '');
      }
      rioraLockBodyScroll();
    }

    var isNativeDialog = typeof modal.close === 'function';

    function restoreFocus() {
      var trigger = lastTrigger;
      lastTrigger = null;
      if (!trigger || typeof trigger.focus !== 'function') return;
      /* Run after the browser's own native close()/Escape focus handling finishes,
         which otherwise races with (and can override) this explicit focus() call.
         setTimeout (not requestAnimationFrame) so this still fires promptly even
         if the tab is backgrounded right as the dialog closes. */
      window.setTimeout(function () {
        trigger.focus();
      }, 0);
    }

    function closeModal() {
      if (isNativeDialog) {
        modal.close();
      } else {
        modal.removeAttribute('open');
      }
      /* Called directly here rather than solely from the dialog's native 'close'
         event — that event isn't reliably synchronous/observed across browsers,
         so button-click and backdrop-click closes must not depend on it firing. */
      rioraUnlockBodyScroll();
      restoreFocus();
    }

    /* Escape-key closes call the dialog's own close() directly and never go
       through closeModal() above, so unlock + restore focus here too.
       restoreFocus()/rioraUnlockBodyScroll() are both safe to double-fire
       (idempotent) if this also happens to run alongside closeModal(). */
    if (isNativeDialog) {
      modal.addEventListener('close', function () {
        rioraUnlockBodyScroll();
        restoreFocus();
      });
    }

    document.querySelectorAll('[' + triggerAttr + ']').forEach(function (trigger) {
      trigger.addEventListener('click', function (e) {
        e.preventDefault();
        openModal(trigger);
      });
    });

    if (modalClose) modalClose.addEventListener('click', closeModal);

    modal.addEventListener('click', function (e) {
      if (e.target === modal) closeModal();
    });
  }

  setupImagePopupModal('riora-label-modal', 'data-riora-label-modal-trigger', 'data-riora-label-modal-close');
  setupImagePopupModal('riora-test-report-modal', 'data-riora-test-report-modal-trigger', 'data-riora-test-report-modal-close');

  /* ---------- Video testimonials block: Swiper carousel of video/poster cards ---------- */
  (function () {
    var widgets = Array.from(document.querySelectorAll('[data-riora-vidtest]'));
    if (!widgets.length) return;

    function boot() {
      if (typeof Swiper === 'undefined') { setTimeout(boot, 120); return; }
      widgets.forEach(function (widget) {
        var el = widget.querySelector('[data-riora-vidtest-swiper]');
        if (!el || el.swiper) return;
        var slidesDesktop = parseInt(widget.getAttribute('data-riora-vidtest-slides-desktop'), 10) || 3;
        new Swiper(el, {
          slidesPerView: 1.4,
          spaceBetween: 16,
          loop: false,
          breakpoints: { 750: { slidesPerView: slidesDesktop, spaceBetween: 16 } },
          navigation: {
            prevEl: widget.querySelector('[data-riora-vidtest-prev]'),
            nextEl: widget.querySelector('[data-riora-vidtest-next]')
          }
        });
      });
    }
    boot();

    widgets.forEach(function (widget) {
      widget.querySelectorAll('.riora-vidtest__play').forEach(function (btn) {
        btn.addEventListener('click', function () {
          var v = this.closest('.riora-vidtest__video-wrap').querySelector('video');
          if (!v) return;
          if (v.paused) { v.play(); this.style.opacity = '0'; } else { v.pause(); this.style.opacity = '1'; }
        });
      });
    });
  })();

  /* ---------- Text testimonials block: Swiper carousel of star-rating quote cards ---------- */
  (function () {
    var widgets = Array.from(document.querySelectorAll('[data-riora-ttest]'));
    if (!widgets.length) return;

    function boot() {
      if (typeof Swiper === 'undefined') { setTimeout(boot, 120); return; }
      widgets.forEach(function (widget) {
        var el = widget.querySelector('[data-riora-ttest-swiper]');
        if (!el || el.swiper) return;
        var slidesDesktop = parseInt(widget.getAttribute('data-riora-ttest-slides-desktop'), 10) || 3;
        new Swiper(el, {
          slidesPerView: 1.15,
          spaceBetween: 16,
          loop: false,
          breakpoints: { 750: { slidesPerView: slidesDesktop, spaceBetween: 16 } },
          navigation: {
            prevEl: widget.querySelector('[data-riora-ttest-prev]'),
            nextEl: widget.querySelector('[data-riora-ttest-next]')
          }
        });
      });
    }
    boot();
  })();

  /* ---------- Text slider blocks: one line of text at a time, swiped left/right ---------- */
  document.querySelectorAll('[data-riora-textslider]').forEach(function (widget) {
    var viewport = widget.querySelector('[data-riora-textslider-viewport]');
    var slides = Array.from(widget.querySelectorAll('[data-riora-textslider-slide]'));
    var prevBtn = widget.querySelector('[data-riora-textslider-prev]');
    var nextBtn = widget.querySelector('[data-riora-textslider-next]');
    if (slides.length < 2) return;
    var curIndex = 0;
    var threshold = parseInt(widget.getAttribute('data-riora-textslider-threshold'), 10) || 40;

    function showSlide(i) {
      if (i < 0) i = slides.length - 1;
      if (i >= slides.length) i = 0;
      curIndex = i;
      slides.forEach(function (s, idx) { s.classList.toggle('is-active', idx === i); });
    }

    var autoTimer = null;
    function startAuto() {
      stopAuto();
      autoTimer = setInterval(function () { showSlide(curIndex + 1); }, 5000);
    }
    function stopAuto() {
      if (autoTimer) { clearInterval(autoTimer); autoTimer = null; }
    }

    if (prevBtn) {
      prevBtn.addEventListener('click', function () { showSlide(curIndex - 1); startAuto(); });
    }
    if (nextBtn) {
      nextBtn.addEventListener('click', function () { showSlide(curIndex + 1); startAuto(); });
    }

    if (viewport) {
      var touchStartX = 0;
      viewport.addEventListener('touchstart', function (e) {
        touchStartX = e.changedTouches[0].screenX;
        stopAuto();
      }, { passive: true });
      viewport.addEventListener('touchend', function (e) {
        var diff = touchStartX - e.changedTouches[0].screenX;
        if (Math.abs(diff) > threshold) showSlide(curIndex + (diff > 0 ? 1 : -1));
        startAuto();
      }, { passive: true });
    }

    startAuto();
  });

  /* ---------- Generic mobile swipe-row nav: ingredients / reviews / clinicians / video & photo strips ---------- */
  document.querySelectorAll('[data-riora-hscroll]').forEach(function (wrap) {
    var track = wrap.querySelector('[data-riora-hscroll-track]');
    var prevBtn = wrap.querySelector('[data-riora-hscroll-prev]');
    var nextBtn = wrap.querySelector('[data-riora-hscroll-next]');
    if (!track || !prevBtn || !nextBtn) return;

    function step() {
      var card = track.children[0];
      if (!card) return track.clientWidth;
      var style = window.getComputedStyle(track);
      var gap = parseFloat(style.columnGap) || parseFloat(style.gap) || 0;
      return card.getBoundingClientRect().width + gap;
    }

    /* Nothing to scroll (every card already fits) — hide the arrows outright rather
       than leaving a dead greyed-out pair sitting there. Inline display beats the
       class rules that turn the nav on per breakpoint; '' hands control back to them. */
    var nav = prevBtn.closest('.riora-hscroll-nav');
    function updateDisabled() {
      var scrollable = track.scrollWidth - track.clientWidth > 2;
      if (nav) nav.style.display = scrollable ? '' : 'none';
      else { prevBtn.hidden = !scrollable; nextBtn.hidden = !scrollable; }
      prevBtn.disabled = track.scrollLeft <= 2;
      nextBtn.disabled = track.scrollLeft >= track.scrollWidth - track.clientWidth - 2;
    }

    prevBtn.addEventListener('click', function () { track.scrollBy({ left: -step(), behavior: 'smooth' }); });
    nextBtn.addEventListener('click', function () { track.scrollBy({ left: step(), behavior: 'smooth' }); });
    track.addEventListener('scroll', updateDisabled, { passive: true });
    /* Whether it overflows depends on the width it ends up with, so re-check as the
       track resizes — a first measurement taken before images/fonts settle (or before
       a hidden parent opens) is otherwise never corrected. ResizeObserver catches the
       cases window resize can't (a parent opening, late-loading media); resize and
       load stay as a floor for when the observer is unavailable or throttled. */
    if (typeof ResizeObserver !== 'undefined') {
      new ResizeObserver(updateDisabled).observe(track);
    }
    window.addEventListener('resize', updateDisabled);
    window.addEventListener('load', updateDisabled);
    updateDisabled();
  });

  document.querySelectorAll('[data-riora-oos-notify]').forEach(function (wrap) {
    var emailInput = wrap.querySelector('[data-riora-oos-email]');
    var submitBtn = wrap.querySelector('[data-riora-oos-submit]');
    var formRow = wrap.querySelector('.riora-buybox__oos-form');
    var successEl = wrap.querySelector('[data-riora-oos-success]');
    var errorEl = wrap.querySelector('[data-riora-oos-error]');
    var listId = wrap.getAttribute('data-riora-oos-list-id');
    var productTitle = wrap.getAttribute('data-riora-oos-product-title') || '';
    var productUrl = wrap.getAttribute('data-riora-oos-product-url') || '';
    var variantId = wrap.getAttribute('data-riora-oos-variant-id') || '';
    var variantTitle = wrap.getAttribute('data-riora-oos-variant-title') || '';
    var btnDefaultText = submitBtn.textContent;

    function submitEmail(e) {
      if (e) { e.preventDefault(); e.stopPropagation(); }
      var email = emailInput.value.trim();
      if (!/^\S+@\S+\.\S+$/.test(email)) { emailInput.focus(); return; }

      errorEl.hidden = true;
      submitBtn.disabled = true;
      submitBtn.textContent = 'Submitting…';

      fetch('https://a.klaviyo.com/client/subscriptions/?company_id=T8v7Cg', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'revision': '2025-10-15'
        },
        body: JSON.stringify({
          data: {
            type: 'subscription',
            attributes: {
              profile: {
                data: {
                  type: 'profile',
                  attributes: {
                    email: email,
                    properties: {
                      source: 'Out of Stock Notify',
                      product_title: productTitle,
                      product_url: productUrl,
                      variant_id: variantId,
                      variant_title: variantTitle
                    },
                    subscriptions: {
                      email: { marketing: { consent: 'SUBSCRIBED' } }
                    }
                  }
                }
              },
              custom_source: 'Out of Stock Notify: ' + productTitle
            },
            relationships: {
              list: { data: { type: 'list', id: listId } }
            }
          }
        })
      })
      .then(function (res) {
        if (res.ok) {
          formRow.hidden = true;
          successEl.hidden = false;
          return;
        }
        return res.text().then(function (body) {
          console.error('Klaviyo error ' + res.status + ':', body);
          throw new Error('Klaviyo error ' + res.status);
        });
      })
      .catch(function () {
        errorEl.hidden = false;
        submitBtn.disabled = false;
        submitBtn.textContent = btnDefaultText;
      });
    }

    submitBtn.addEventListener('click', submitEmail);
    emailInput.addEventListener('keydown', function (e) {
      if (e.key === 'Enter') submitEmail(e);
    });
  });

  /* ---------- "Ships by" estimate: before the cutoff hour, ships today;
     at/after it, ships the next day. Computed from the visitor's own clock. ---------- */
  document.querySelectorAll('[data-riora-ships-by]').forEach(function (el) {
    var textEl = el.querySelector('[data-riora-ships-by-text]');
    if (!textEl) return;

    var cutoffHour = parseInt(el.getAttribute('data-riora-ships-by-cutoff-hour'), 10);
    if (isNaN(cutoffHour)) cutoffHour = 14;

    var prefix = textEl.textContent.trim();
    var now = new Date();
    var isAfterCutoff = now.getHours() >= cutoffHour;

    /* Friday after the cutoff would naively land on Saturday — skip the
       weekend and ship Monday instead. */
    var daysToAdd = isAfterCutoff ? 1 : 0;
    if (now.getDay() === 5 && isAfterCutoff) daysToAdd = 3;

    var shipDate = new Date(now);
    shipDate.setDate(now.getDate() + daysToAdd);

    var weekdays = ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'];
    var months = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];
    var formatted = weekdays[shipDate.getDay()] + ' ' + months[shipDate.getMonth()] + ' ' + shipDate.getDate();

    textEl.textContent = (prefix ? prefix + ' ' : '') + formatted;
  });

  document.addEventListener('keydown', function (e) {
    if (e.key !== 'Enter' && e.key !== ' ') return;
    var el = e.target.closest ? e.target.closest('.riora-rating-badge[data-riora-scroll-target]') : null;
    if (!el) return;
    e.preventDefault();
    el.click();
  });

  /* ---------- "View full panel" style buttons: smooth-scroll to a target section, offset for sticky header ---------- */
  document.addEventListener('click', function (e) {
    var link = e.target.closest('[data-riora-scroll-target]');
    if (!link) return;
    var key = link.getAttribute('data-riora-scroll-target');
    /* Online Store 2.0 prefixes rendered section ids with the template's own id
       (e.g. shopify-section-template--123__key), so match by suffix, not exact id. */
    var target = document.getElementById(key) || document.querySelector('[id$="__' + key + '"]');
    if (!target && key === 'judgeme_product_reviews') target = document.querySelector('[id*="judge_me_reviews_review_widget"]');
    if (!target) return;
    e.preventDefault();

    function scrollToTarget() {
      var header = document.querySelector('.shopify-section-header-sticky');
      var offset = (header ? header.offsetHeight : 0) + 16;
      var top = target.getBoundingClientRect().top + window.pageYOffset - offset;
      window.scrollTo({ top: top, behavior: 'smooth' });
    }

    scrollToTarget();
    /* Right after a fresh page load, images above the target may still be loading and
       shifting layout, so the first scroll can land short. Re-correct once everything
       (including images) has actually finished loading. */
    if (document.readyState !== 'complete') {
      window.addEventListener('load', scrollToTarget, { once: true });
    }
  });
})();


(function () {
  /* Free gifts are added with a hidden form post instead of fetch. Shopify (and Meta, GA4, Klaviyo, Elevar)
     log an add-to-cart for every line added through fetch/XHR, so each order-box click counted as 4 add-to-carts.
     A form post into a hidden frame adds the same lines without firing those events.
     Safety net: if the gifts aren't in the cart after ~6s, they are added the normal way (events fire, gifts still land). */
  if (!window.rioraAddGiftsQuiet) {
    window.rioraAddGiftsQuiet = function (items) {
      items = (items || []).filter(function (it) { return it && it.id; });
      if (!items.length) return Promise.resolve();
      var json = { 'Content-Type': 'application/json', 'Accept': 'application/json' };
      function cartHas() {
        return fetch('/cart.js', { headers: { 'Accept': 'application/json' }, cache: 'no-store' })
          .then(function (r) { return r.json(); })
          .then(function (cart) {
            var have = {};
            (cart.items || []).forEach(function (it) { have[String(it.variant_id)] = true; });
            return items.filter(function (it) { return !have[String(it.id)]; });
          });
      }
      var name = 'riora-gift-' + Date.now();
      var frame = document.createElement('iframe');
      frame.name = name;
      frame.title = 'Adding free gifts';
      frame.tabIndex = -1;
      frame.setAttribute('aria-hidden', 'true');
      frame.style.cssText = 'position:absolute;width:0;height:0;border:0;visibility:hidden';
      var form = document.createElement('form');
      form.method = 'POST';
      form.action = '/cart/add';
      form.target = name;
      form.style.display = 'none';
      function field(n, v) { var i = document.createElement('input'); i.type = 'hidden'; i.name = n; i.value = v; form.appendChild(i); }
      items.forEach(function (it, i) {
        field('items[' + i + '][id]', it.id);
        field('items[' + i + '][quantity]', it.quantity || 1);
        var p = it.properties || {};
        Object.keys(p).forEach(function (k) { field('items[' + i + '][properties][' + k + ']', p[k]); });
      });
      field('return_to', '/cart.js');
      document.body.appendChild(frame);
      document.body.appendChild(form);
      form.submit();
      function cleanup() { if (frame.parentNode) frame.parentNode.removeChild(frame); if (form.parentNode) form.parentNode.removeChild(form); }
      var tries = 0;
      function check() {
        return new Promise(function (r) { setTimeout(r, tries === 0 ? 500 : 400); })
          .then(cartHas)
          .then(function (missing) {
            if (!missing.length) return null;
            if (++tries < 12) return check();
            return missing;
          });
      }
      return check()
        .catch(function () { return items; })
        .then(function (missing) {
          cleanup();
          if (!missing || !missing.length) return;
          return fetch('/cart/add.js', { method: 'POST', headers: json, body: JSON.stringify({ items: missing }) })
            .then(function (res) { if (!res.ok) throw new Error('gift add failed ' + res.status); });
        });
    };
  }

  /* Adds the main item plus its gifts. A gift already in the cart (same gift on another variant) is never
     added twice: its line stays at quantity 1 and this variant is appended to its sponsor list. */
  window.rioraAddWithGifts = function (mainItem, giftVariantIds) {
    var sponsor = String(mainItem.id);
    var routes = (window.Shopify && window.Shopify.routes) || {};
    var cartDrawer = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
    var sectionIds = cartDrawer && cartDrawer.getSectionsToRender ? cartDrawer.getSectionsToRender().map(function (s) { return s.id; }) : null;
    return fetch('/cart.js').then(function (r) { return r.json(); }).then(function (cart) {
      var existing = {};
      cart.items.forEach(function (item) { if (item.properties && item.properties._riora_gift_for) existing[String(item.variant_id)] = item; });
      var items = [];
      var share = [];
      giftVariantIds.forEach(function (vid) {
        var line = existing[String(vid)];
        if (line) { share.push(line); return; }
        items.push({ id: vid, quantity: 1, properties: { _riora_gift_for: sponsor } });
      });
      var body = { items: [mainItem] };
      if (sectionIds) { body.sections = sectionIds; body.sections_url = window.location.pathname; }
      // Product first, then its gifts (see rioraAddGiftsQuiet). The drawer is re-rendered after the gifts land.
      return fetch(routes.cart_add_url || '/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify(body)
      })
        .then(function (res) { if (!res.ok) throw new Error('cart add failed'); return res.json(); })
        .then(function (res) { return window.rioraAddGiftsQuiet(items).then(function () { return res; }); })
        .then(function (res) {
          var chain = Promise.resolve();
          var changed = items.length > 0;
          share.forEach(function (line) {
            var list = String(line.properties._riora_gift_for).split(',').filter(Boolean);
            if (list.indexOf(sponsor) !== -1) return;
            list.push(sponsor);
            changed = true;
            var props = {};
            Object.keys(line.properties).forEach(function (k) { props[k] = line.properties[k]; });
            props._riora_gift_for = list.join(',');
            chain = chain.then(function () {
              return fetch('/cart/change.js', {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify({ id: line.key, quantity: line.quantity, properties: props })
              });
            });
          });
          return chain.then(function () {
            if (!changed || !sectionIds) return res;
            return fetch((routes.root || '/') + '?sections=' + sectionIds.join(',')).then(function (r) { return r.json(); }).then(function (sections) {
              res.sections = sections;
              return res;
            });
          });
        })
        .then(function (res) {
          if (cartDrawer && cartDrawer.renderContents) { cartDrawer.renderContents(res); }
          else { window.location.href = routes.cart_url || '/cart'; }
        });
    });
  };
})();

(function () {
  var timer = null;
  function patchThirdParty() {
    document.querySelectorAll('iframe:not([title])').forEach(function (f) {
      var src = f.getAttribute('src') || '';
      if (/mediadelivery.net|judge.me/.test(src)) f.setAttribute('title', 'Customer video review');
    });
    document.querySelectorAll('a.jdgm-write-review-modal__btn:not([href])').forEach(function (a) {
      a.setAttribute('href', '#');
      a.setAttribute('role', 'button');
      a.addEventListener('click', function (e) { e.preventDefault(); });
    });
  }
  function schedule() {
    if (timer) return;
    timer = setTimeout(function () { timer = null; patchThirdParty(); }, 400);
  }
  patchThirdParty();
  if (document.body && typeof MutationObserver !== 'undefined') {
    new MutationObserver(schedule).observe(document.body, { childList: true, subtree: true });
  }
})();

(function () {
  var original = window.rioraAddWithGifts;
  if (!original) return;
  var inflight = null;
  window.rioraAddWithGifts = function () {
    if (inflight) return inflight;
    var buttons = document.querySelectorAll('[data-riora-sticky-atc], [data-riora-primary-atc]');
    buttons.forEach(function (b) {
      b.classList.add('is-adding');
      b.setAttribute('aria-busy', 'true');
    });
    var request = original.apply(this, arguments);
    function finish() {
      inflight = null;
      buttons.forEach(function (b) {
        b.classList.remove('is-adding');
        b.removeAttribute('aria-busy');
      });
    }
    request.then(finish, finish);
    inflight = request;
    return request;
  };
})();


(function () {
  /* "Try it now" buttons in other PDP sections (clinicians, comparison table, text slider…) point at the old
     buy box (#riora-buybox-form or #riora-buy). When the page shows the try-before-you-buy order box instead,
     that form isn't on the page and #riora-buy is the top of the product section, so the buttons did nothing
     useful. Send every buy-box link to whichever buy box is actually on the page. */
  if (window.__rioraBuyLinks) return;
  window.__rioraBuyLinks = true;
  var KEYS = { 'riora-buybox-form': 1, 'riora-buy': 1, 'buy': 1, 'offer': 1 };
  function buyBox() {
    var el = document.querySelector('[data-rtb]') || document.querySelector('.riora-buybox, .riora-qpbox, [data-riora-buybox]');
    return el && el.offsetParent !== null ? el : null;
  }
  document.addEventListener('click', function (e) {
    var a = e.target.closest ? e.target.closest('a[href^="#"], [data-riora-scroll-target]') : null;
    if (!a || a.closest('[data-rtb]')) return;
    var key = a.getAttribute('data-riora-scroll-target') || (a.getAttribute('href') || '').slice(1);
    if (!KEYS[key]) return;
    var box = buyBox();
    if (!box) return;
    e.preventDefault();
    e.stopPropagation();
    var header = document.querySelector('.shopify-section-header-sticky');
    var offset = (header ? header.offsetHeight : 0) + 16;
    window.scrollTo({ top: Math.max(0, box.getBoundingClientRect().top + window.pageYOffset - offset), behavior: 'smooth' });
  }, true);
})();
